import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, userProfile, signOut, loading } = useAuth();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const handleSignOut = async () => {
    try {
      const { error } = await signOut();
      if (!error) {
        navigate('/user-authentication-and-login');
      }
    } catch (err) {
      console.error('Sign out error:', err);
    }
  };

  // Don't show header on login page
  if (location?.pathname === '/user-authentication-and-login') {
    return null;
  }

  if (loading || !user) {
    return null;
  }

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center">
              <Icon name="Building2" size={20} className="text-white" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-slate-900">Bundesagentur für Arbeit</h1>
              <p className="text-xs text-slate-600">Mitarbeiterportal</p>
            </div>
          </div>

          {/* User Profile & Sign Out */}
          <div className="flex items-center gap-4">
            <div className="relative">
              <button
                onClick={() => setShowProfileMenu(!showProfileMenu)}
                className="flex items-center gap-3 px-4 py-2 rounded-lg hover:bg-slate-50 transition-colors"
              >
                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-orange-500 to-teal-500 flex items-center justify-center">
                  <span className="text-white font-semibold text-sm">
                    {userProfile?.full_name?.charAt(0) || user?.email?.charAt(0)?.toUpperCase()}
                  </span>
                </div>
                <div className="text-left">
                  <p className="text-sm font-semibold text-slate-900">
                    {userProfile?.full_name || user?.email}
                  </p>
                  <p className="text-xs text-slate-600 capitalize">
                    {userProfile?.role?.replace('_', ' ') || 'Mitarbeiter'}
                  </p>
                </div>
                <Icon 
                  name={showProfileMenu ? "ChevronUp" : "ChevronDown"} 
                  size={16} 
                  className="text-slate-400" 
                />
              </button>

              {showProfileMenu && (
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-slate-200 py-2">
                  <div className="px-4 py-2 border-b border-slate-100">
                    <p className="text-sm font-medium text-slate-900">
                      {userProfile?.full_name || user?.email}
                    </p>
                    <p className="text-xs text-slate-600">{user?.email}</p>
                  </div>
                  <button
                    onClick={handleSignOut}
                    className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
                  >
                    <Icon name="LogOut" size={16} />
                    Abmelden
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;